import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Cards1.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'

class Cards1 extends React.Component {
  
  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { data, margin, cols, bg } = this.props

    return (
      <section className={`${styles.section} ${styles[margin]}`}>
        <Container>
          {data?.title != `` &&
            <WhiteBlockTitle
              title={data?.title}
              text={``}
              className={styles.title}
            />
          }
          <div className={`${styles.list} ${styles[`grid-${cols}`]}`}>
            <div className={`${styles.block} ${styles[`bg-${bg}`]}`}>
              <div className={styles.b_title}>
                <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: data?.title2}} />
                <div>{this.formatSlideNumber(0)}</div>
              </div>
              <div className={styles.b_text} dangerouslySetInnerHTML={{__html: data?.text}} />
              <div className={styles.b_materials}>
                {data?.materials.map( ( cel, k ) => (
                  <div key={k} className={styles.b_materials_el}>
                    <Image className={styles.b_materials_el_image} src={cel?.image} width={277} height={50} alt={cel?.name} />
                    <div className={styles.b_materials_el_name} dangerouslySetInnerHTML={{__html: cel?.name}} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Cards1.propTypes = {
  data: PropTypes.object,
  margin: PropTypes.string,
  cols: PropTypes.string,
  bg: PropTypes.string
}

Cards1.defaultProps = {
  data: {},
  margin: `none`,
  cols: `1`,
  bg: `1`
}

export default Cards1